import { useMemo, type PropsWithChildren } from 'react'
import { BlogArticlePills } from './BlogArticlePills';
import { BlogArticleTitle } from './BlogArticleTitle';
import { BlogArticleDescription } from './BlogArticleDescription';
import { BlogArticleDate } from './BlogArticleDate';

type BlogArticleContent = PropsWithChildren;

export const BlogArticleContent = ( { children }: BlogArticleContent ) => {

  const Components = useMemo ( () => {
    return Array.isArray( children ) ? children : [ children ];
  }, [ children ] );

  const Date = Components.find( c => c?.type?.displayName === BlogArticleDate.displayName );
  const Title = Components.find( c => c?.type?.displayName === BlogArticleTitle.displayName );
  const Description = Components.find( c => c?.type?.displayName === BlogArticleDescription.displayName );

  const Pills = Components.find( c => c?.type?.displayName === BlogArticlePills.displayName )

  return (
    <div className={ 'flex flex-col gap-3' }>
      { ( Date || Title || Description ) && (
        <div className={ 'flex flex-col gap-1.5' }>
          { Date }
          { Title }
          { Description }
        </div>
      )}
      { Pills }
    </div>
  )
}
BlogArticleContent.displayName = 'BlogArticleContent';
